const ChapterBadge = ({ number, name }) => (
  <div
    className="mb-5 flex items-center justify-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-white/30"
    data-testid={`chapter-badge-${number}`}
  >
    <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#00E5FF]/50" />
    <span className="flex items-center">
      <span className="text-[#00E5FF]/80">{number}</span>
      <span className="mx-2 text-white/20">//</span>
      <span>{name}</span>
    </span>
    <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#00E5FF]/50" />
  </div>
);

export default ChapterBadge;
